import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignSecurityGroupsToUser } from '../services/security-groups';
import type { AssignUserToGroupsPayload, AssignUserToGroupsResponse } from '../types/security-admin.types';

export function useAssignUserToGroupsMutation(userId: string) {
  const queryClient = useQueryClient();
  return useMutation<AssignUserToGroupsResponse, unknown, AssignUserToGroupsPayload>({
    mutationFn: (payload) => assignSecurityGroupsToUser(userId, payload),
    onSuccess: (result, variables) => {
      queryClient.invalidateQueries({ queryKey: ['security', 'users', userId, 'groups'] });
      queryClient.invalidateQueries({ queryKey: ['security', 'users', userId, 'assignable-groups'] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
      const newlyAssignedIds = variables.group_ids.filter(
        (id) => !result.skipped_group_ids.includes(id),
      );
      for (const id of newlyAssignedIds) {
        queryClient.invalidateQueries({ queryKey: ['security-group', id] });
      }
    },
  });
}
